export type LegalDocKey = 'register' | 'privacy' | 'disclaimer';

export const LEGAL_PATHS: Record<LegalDocKey, string> = {
  register: '/legal/register',
  privacy: '/legal/privacy',
  disclaimer: '/legal/disclaimer',
};

export function getLegalDocKeyFromPath(path: string): LegalDocKey | null {
  const entry = Object.entries(LEGAL_PATHS).find(([, p]) => p === path);
  return entry ? (entry[0] as LegalDocKey) : null;
}

/** App WebView / 外链使用的完整 URL（默认带内嵌参数） */
export function buildLegalAbsoluteUrl(
  docKey: LegalDocKey,
  options?: { embed?: boolean; platform?: string }
): string {
  const base = String(import.meta.env.VITE_BASE_URL || '').replace(/\/$/, '');
  const path = LEGAL_PATHS[docKey];
  const embed = options?.embed !== false;
  if (!embed) {
    return `${base}${path}`;
  }
  const params = new URLSearchParams();
  params.set('embed', '1');
  params.set('platform', options?.platform ?? 'rn');
  return `${base}${path}?${params.toString()}`;
}
